import script from "./AnnotationContextPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnotationContextPanel.vue?vue&type=script&setup=true&lang=ts"

import "./AnnotationContextPanel.vue?vue&type=style&index=0&id=19697742&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19697742"]])

export default __exports__